import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { QueIncluye } from './components/QueIncluye';
import { IdealPara } from './components/IdealPara';
import { Beneficios } from './components/Beneficios';
import { BonosExclusivos } from './components/BonosExclusivos';
import { PrecioSection } from './components/PrecioSection';
import { Testimonios } from './components/Testimonios';
import { Garantia } from './components/Garantia';
import { FAQSection } from './components/FAQSection';
import { CierreCTA } from './components/CierreCTA';
import { StickyBar } from './components/StickyBar';
import { PurchasePopup } from './components/PurchasePopup';
import { ShieldIcon, ClockIcon, HardDriveIcon } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel – set up the fbq stub first
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    // Load the external script safely via document.head
    if (!document.getElementById('fb-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'fb-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1379305313659580');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-orange-50/50 font-sans text-gray-900 pb-20 md:pb-0" data-id="element-0">
      <HeroSection data-id="element-1" />
      <QueIncluye data-id="element-2" />
      <IdealPara data-id="element-3" />
      <Beneficios data-id="element-4" />
      <BonosExclusivos data-id="element-5" />
      <PrecioSection data-id="element-6" />
      <Testimonios data-id="element-7" />
      <Garantia data-id="element-8" />
      <FAQSection data-id="element-9" />
      <CierreCTA data-id="element-10" />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm border-t border-gray-800" data-id="element-11">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-12">
          <div className="flex items-center gap-2" data-id="element-13">
            <ShieldIcon className="w-4 h-4" data-id="element-14" />
            <span data-id="element-15">Pago seguro</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-16">•</div>
          <div className="flex items-center gap-2" data-id="element-17">
            <HardDriveIcon className="w-4 h-4" data-id="element-18" />
            <span data-id="element-19">Acceso inmediato por Drive</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-20">•</div>
          <div className="flex items-center gap-2" data-id="element-21">
            <ClockIcon className="w-4 h-4" data-id="element-22" />
            <span data-id="element-23">Garantía 7 días</span>
          </div>
        </div>
        <p className="mt-6 text-gray-600 text-xs" data-id="element-24">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>

      <StickyBar data-id="element-25" />
      <PurchasePopup data-id="element-26" />
    </div>;
}